// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* BORDERS */\n\n/* Icons */\n\n/* BORDERS */\n\n/* Icons */\n.release-notes {\n  font-size: 90%;\n  height: 250px;\n  overflow: auto;\n}\n.release-notes ol,\n.release-notes ul {\n  list-style: disc;\n}\n.changelog-text ol,\n.changelog-text ul {\n  list-style: disc;\n}", ""]);
// Exports
module.exports = exports;
